<h1 mat-dialog-title class="notification-title" style="color: #121d50">{{ 'insights.administration.reports.categories.heading' | translate }}</h1>

<mat-dialog-content style="font-weight: normal; color: #121d50; line-height: 1.5">
	<form [formGroup]="assignCategoryForm" (ngSubmit)="assignCategory(assignCategoryForm.value)">
		<div id="assign-category" class="section">
			<p class="sectiontitle">{{ 'insights.administration.reports.categories.heading_assign' | translate }}</p>
			@if (!data.selected.length) {
			<p style="color: #b83204; font-style: normal; font-size: 12px">{{ 'insights.administration.reports.categories.no_reports_selected' | translate }}</p>
			}
			<mat-form-field appearance="fill" class="assign-category-select">
				<mat-label>{{ 'insights.administration.reports.categories.placeholder_select' | translate }}</mat-label>
				<mat-select formControlName="assignCategoryControl">
					<mat-option [value]="{ id: '', name: '' }">{{ 'insights.administration.reports.categories.nocategory' | translate }}</mat-option>
					<!--<mat-option *ngFor="let category of reportService.sortCategories((reportService.reportCategories$ | async), 'name')" [value]="category">-->
					@for (category of availableCategories; track category) {
					<mat-option [value]="category">{{ category['name'] }}</mat-option>
					}
				</mat-select>
			</mat-form-field>
			<div class="buttons">
				<button type="submit" mat-flat-button color="primary" [disabled]="data.selected.length === 0 || assignCategoryForm.invalid">{{ 'insights.administration.reports.categories.button_assign_simple' | translate: {count: data.selected.length} }}</button>
			</div>
		</div>
	</form>

	<details style="margin: 16px 0">
		<summary style="font-weight: bold">{{ 'insights.administration.reports.categories.create_edit_report_categories' | translate }}</summary>
		<p class="sectiontitle">{{ 'insights.administration.reports.categories.heading_existing_categories' | translate }}</p>
		<div id="available-categories" class="available-categories" cdkDropList (cdkDropListDropped)="drop($event)" style="min-height: 200px">
			@for (category of sortedCategories; track category) {
			<div class="category" [id]="category['id']" cdkDrag cdkDragLockAxis="y">
				<span>{{ category['name'] }}</span>
				<span>
					<mat-icon mat-list-icon class="account-select-icon" svgIcon="acies_edit" (click)="editCategory(category)" style="margin-right: 8px"></mat-icon>
					<mat-icon mat-list-icon class="account-select-icon" svgIcon="acies_delete" (click)="deleteCategory(category)"></mat-icon>
				</span>
			</div>
			}
		</div>

		<form [formGroup]="newCategoryForm" (ngSubmit)="addCategory(newCategoryForm.value)">
			<div id="add-category" class="section">
				<p class="sectiontitle">{{ 'insights.administration.reports.categories.heading_create_new' | translate}}</p>
				@if (newCategoryForm.controls['categoryControl'].invalid && (newCategoryForm.controls['categoryControl'].dirty || newCategoryForm.controls['categoryControl'].touched)) {
				<div style="font-size: 12px; color: #b83204; font-style: normal">
					@if (newCategoryForm.controls['categoryControl'].errors['pattern']) {
					<div>{{ "insights.administration.reports.categories.invalid_name" | translate }}</div>
					}
				</div>
				} @if (categoryErrors.length) {
				<div style="color: #ff1212">
					@for (error of categoryErrors; track error) {
					<p>{{ error }}</p>
					}
				</div>
				}
				<mat-form-field appearance="outline" class="new-category">
					<input matInput [placeholder]="'insights.administration.reports.categories.placeholder_enter' | translate" formControlName="categoryControl" maxlength="60" />
				</mat-form-field>

				<div class="buttons">
					<button type="submit" mat-flat-button color="primary" [disabled]="!newCategoryForm.valid">{{ 'insights.administration.reports.categories.button_create' | translate }}</button>
				</div>
			</div>
		</form>
	</details>
</mat-dialog-content>

<mat-dialog-actions [align]="'end'">
	<button mat-flat-button color="primary" (click)="closeDialog()">{{ 'insights.administration.reports.categories.close' | translate }}</button>
</mat-dialog-actions>
